import React from "react";
export const Place = () => (
    <svg
        width="16"
        height="22"
        viewBox="0 0 16 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ marginRight: "5px" }}
    >
        <path
            d="M14.8257 8.46779C14.8257 4.68614 11.7307 1.62061 7.91278 1.62061C4.09491 1.62061 1 4.68614 1 8.46779C1 13.5131 7.91278 19.9999 7.91278 19.9999C7.91278 19.9999 14.8257 13.5131 14.8257 8.46779Z"
            stroke="var(--c1)"
            strokeWidth="1.5"
        />
        <ellipse
            cx="7.91266"
            cy="8.54955"
            rx="3.09259"
            ry="3.06322"
            stroke="var(--c1)"
            strokeWidth="1.5"
        />
    </svg>
);
export const Map = () => (
    <svg
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18.8937 0.957801C18.6473 0.764943 18.3604 0.630597 18.0544 0.564911C17.7485 0.499226 17.4317 0.503918 17.1279 0.578634L13.3037 1.5428C13.1465 1.57533 12.9843 1.57533 12.827 1.5428L7.43204 0.199467C7.10415 0.123615 6.76326 0.123615 6.43537 0.199467L1.87454 1.3478C1.42898 1.45761 1.03313 1.71369 0.750311 2.07507C0.467493 2.43645 0.314053 2.88224 0.314538 3.34113V15.4203C0.311669 15.7339 0.381598 16.0438 0.518825 16.3258C0.656051 16.6078 0.856831 16.8541 1.10537 17.0453C1.35175 17.2382 1.63873 17.3725 1.94463 17.4382C2.25054 17.5039 2.56738 17.4992 2.87121 17.4245L6.69537 16.4603C6.8526 16.4278 7.01481 16.4278 7.17204 16.4603L12.567 17.8036C12.7309 17.8383 12.8979 17.8564 13.0654 17.8578C13.2328 17.8558 13.3997 17.8377 13.5637 17.8036L18.1245 16.6553C18.5701 16.5455 18.9659 16.2894 19.2488 15.928C19.5316 15.5666 19.685 15.1209 19.6845 14.662V2.5828C19.6874 2.26922 19.6175 1.95926 19.4803 1.67728C19.343 1.39531 19.1422 1.14903 18.8937 0.957801ZM6.39204 15.4203L2.6112 16.3628C2.46746 16.4013 2.31676 16.4059 2.17091 16.3764C2.02506 16.347 1.88802 16.2841 1.7705 16.1928C1.65299 16.1016 1.5582 15.9843 1.49355 15.8503C1.42891 15.7163 1.39616 15.5691 1.39787 15.4203V3.34113C1.39852 3.12452 1.47128 2.9143 1.60468 2.74363C1.73807 2.57297 1.9245 2.45158 2.13454 2.39863L6.39204 1.32613V15.4203ZM12.5237 16.677L7.47537 15.4203V1.32613L12.5237 2.5828V16.677ZM18.6012 14.662C18.6006 14.8786 18.5278 15.0888 18.3944 15.2595C18.261 15.4301 18.0746 15.5515 17.8645 15.6045L13.607 16.677V2.5828L17.3879 1.6403C17.5326 1.6031 17.684 1.59937 17.8304 1.6294C17.9768 1.65944 18.1144 1.72244 18.2329 1.81363C18.3494 1.90479 18.4433 2.02164 18.5072 2.15506C18.571 2.28849 18.6032 2.43488 18.6012 2.5828V14.662Z"
            fill="#353B47"
        />
    </svg>
);
export const Share = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 17.619"
    >
        <g id="share" transform="translate(-419.5 -998.381)">
            <path
                id="Trazado_3253"
                data-name="Trazado 3253"
                d="M274.5,301.774V308.5h-16v-6.726"
                transform="translate(162 706.5)"
                fill="none"
                stroke="var(--c4)"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
            <g
                id="Grupo_2465"
                data-name="Grupo 2465"
                transform="translate(0.532)"
            >
                <path
                    id="Trazado_3254"
                    data-name="Trazado 3254"
                    d="M338.25,292.5H344.2v5.953"
                    transform="translate(-22.54 1036.355) rotate(-45)"
                    fill="none"
                    stroke="var(--c4)"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <line
                    id="Línea_536"
                    data-name="Línea 536"
                    y2="9"
                    transform="translate(427.677 999.5)"
                    fill="none"
                    stroke="var(--c4)"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
            </g>
        </g>
    </svg>
);

export const NewBack = () => (
    <svg
        width="19"
        height="17"
        viewBox="0 0 19 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: "20px", height: "20px", marginRight: "15px" }}
    >
        <path
            d="M8.89551 15.689L1.55096 8.34442L8.89554 0.999836"
            stroke="#333"
            strokeWidth="2"
        />
        <line
            x1="3"
            y1="8.40771"
            x2="19"
            y2="8.40771"
            stroke="#333"
            strokeWidth="2"
        />
    </svg>
);

export const ShoppingCart = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 18 18" fill="var(--c4)">
    <path d="M16.0957 9.83594L17.0488 4.60938C17.0655 4.51961 17.0614 4.42723 17.0371 4.33925C17.0127 4.25127 16.9686 4.16999 16.9082 4.10156C16.8505 4.03092 16.7778 3.97396 16.6954 3.93478C16.6129 3.89561 16.5229 3.87519 16.4316 3.875H3.83008L3.44727 1.77344C3.39439 1.48652 3.24281 1.22714 3.0188 1.04022C2.79479 0.853308 2.51245 0.750638 2.2207 0.75H0.806641C0.64088 0.75 0.481909 0.815848 0.364699 0.933058C0.247489 1.05027 0.181641 1.20924 0.181641 1.375C0.181641 1.54076 0.247489 1.69973 0.364699 1.81694C0.481909 1.93415 0.64088 2 0.806641 2H2.2207L4.36133 13.7969C4.05613 14.0657 3.83191 14.4143 3.71387 14.8035C3.59582 15.1927 3.58862 15.6071 3.69307 16.0002C3.79753 16.3933 4.00949 16.7494 4.30517 17.0287C4.60085 17.308 4.96853 17.4993 5.36692 17.5811C5.76531 17.663 6.17863 17.6322 6.56047 17.4921C6.94231 17.3521 7.27754 17.1083 7.52853 16.7883C7.77951 16.4683 7.93629 16.0846 7.98128 15.6804C8.02627 15.2761 7.95768 14.8674 7.7832 14.5H11.9551C11.7519 14.9283 11.6934 15.4109 11.7883 15.8753C11.8831 16.3397 12.1262 16.7607 12.4811 17.075C12.8359 17.3893 13.2832 17.5798 13.7556 17.6179C14.2281 17.656 14.7001 17.5397 15.1007 17.2863C15.5013 17.033 15.8088 16.6564 15.9769 16.2132C16.1449 15.77 16.1645 15.2842 16.0326 14.8289C15.9008 14.3737 15.6246 13.9735 15.2457 13.6888C14.8668 13.404 14.4056 13.25 13.9316 13.25H5.5332L5.18945 11.375H14.252C14.6908 11.3748 15.1157 11.2206 15.4526 10.9394C15.7895 10.6582 16.0171 10.2677 16.0957 9.83594ZM6.74414 15.4375C6.74414 15.6229 6.68916 15.8042 6.58614 15.9583C6.48313 16.1125 6.33671 16.2327 6.16541 16.3036C5.9941 16.3746 5.8056 16.3932 5.62374 16.357C5.44189 16.3208 5.27484 16.2315 5.14373 16.1004C5.01262 15.9693 4.92333 15.8023 4.88715 15.6204C4.85098 15.4385 4.86955 15.25 4.9405 15.0787C5.01146 14.9074 5.13162 14.761 5.28579 14.658C5.43996 14.555 5.62122 14.5 5.80664 14.5C6.05528 14.5 6.29374 14.5988 6.46955 14.7746C6.64537 14.9504 6.74414 15.1889 6.74414 15.4375ZM14.8691 15.4375C14.8691 15.6229 14.8142 15.8042 14.7111 15.9583C14.6081 16.1125 14.4617 16.2327 14.2904 16.3036C14.1191 16.3746 13.9306 16.3932 13.7487 16.357C13.5669 16.3208 13.3998 16.2315 13.2687 16.1004C13.1376 15.9693 13.0483 15.8023 13.0122 15.6204C12.976 15.4385 12.9945 15.25 13.0655 15.0787C13.1365 14.9074 13.2566 14.761 13.4108 14.658C13.565 14.555 13.7462 14.5 13.9316 14.5C14.1803 14.5 14.4187 14.5988 14.5946 14.7746C14.7704 14.9504 14.8691 15.1889 14.8691 15.4375ZM4.05664 5.125H15.6816L14.8691 9.60938C14.8434 9.75421 14.7674 9.88533 14.6545 9.97964C14.5416 10.074 14.3991 10.1254 14.252 10.125H4.96289L4.05664 5.125Z"/>
    </svg>
);

export const AngleUp = () => (
    <svg viewBox="0 0 32 32" width={"40px"} version="1.1" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="icomoon-ignore"> </g> <path d="M16.767 12.809l-0.754-0.754-6.035 6.035 0.754 0.754 5.281-5.281 5.256 5.256 0.754-0.754-3.013-3.013z" fill="#353B47"> </path> </g></svg>
);

